<template>
  <div v-if="propData.outcome.isEqualTo(4)" class="control proposal-outcome">
    <div class="tags has-addons">
      <span class="tag is-dark">Outcome</span>
      <span class="tag" :class="proposalStates[propData.outcome].tagClass" >
        <template v-if="propData.poll.votingEndBlock.isGreaterThan($store.currentBlockHeight)">
          {{ proposalStates[propData.outcome].humanReadable }}<div class="loader"></div>
        </template>
        <template v-else>
          Awaiting Finalization <div class="loader"></div>
        </template>
      </span>
    </div>
  </div>
  <div v-else-if="propData.outcome.isEqualTo(1)" class="control proposal-outcome">
    <div class="tags has-addons">
      <span class="tag is-dark">Outcome</span>
      <span class="tag" :class="proposalStates[propData.outcome].tagClass">
        {{ proposalStates[propData.outcome].humanReadable }} <div class="loader"></div>
      </span>
    </div>
  </div>
  <div v-else class="control proposal-outcome">
    <div class="tags has-addons">
      <span class="tag is-dark">Outcome</span>
      <span class="tag" :class="proposalStates[propData.outcome].tagClass" >{{ proposalStates[propData.outcome].humanReadable }}</span>
    </div>
  </div>
</template>

<script>
import Mixins from '../mixins'

export default {
  name: 'ProposalOutcome',
  props: ['propData'],
  mixins: [Mixins],
  async mounted(){
  },
  components: {

  },
  data(){
    return {
    }
  },
  methods: {
    linkToProposal(outcome){
      if (outcome === 4){
        return {name: 'Index'}
      } else if (outcome === 1){
        return {name: 'Timelock'}
      } else {
        return {name: 'ProposalDetail', params: {propNumber: this.propNumber + 1}}
      }
    },
  },
  computed: {
    pollData(){
      return this.propData.poll
    }
  }
}
</script>

<style type="text/scss" lang="scss">
@import '../assets/sass/globals';
.proposal-outcome{
  .tag{
    .loader{
      margin-left: .25rem;
    }
  }
}
</style>
